import React from 'react';

import LiteYoutubeEmbed from 'react-lite-youtube-embed';
import 'react-lite-youtube-embed/dist/LiteYouTubeEmbed.css';

import * as classes from './style.module.scss';

interface Props {
  id: string;
  title: string;
}

export const VideoFrame: React.FC<Props> = ({ id, title }) => {
  return (
    <div className={classes.root}>
      <LiteYoutubeEmbed id={id} title={title} />
    </div>
  );
};
